import {Injectable} from '@angular/core';
import {LoanApplication} from '../model/loan-application.model';
import {LoanApplicationInteractor} from '../interactors/loan-application.interactor';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class LoanApplicationResolver implements Resolve<LoanApplication> {
    private readonly loanApplicationInteractor: LoanApplicationInteractor;

    constructor(loanApplicationInteractor: LoanApplicationInteractor) {
        this.loanApplicationInteractor = loanApplicationInteractor;
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<LoanApplication> {
        return await this.loanApplicationInteractor.get();
    }
}